import { render, staticRenderFns } from "./ReportListPage.vue?vue&type=template&id=b53f15dc&"
import script from "./ReportListPage.vue?vue&type=script&lang=ts&"
export * from "./ReportListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports